import { Button } from '@rocco/components/button';
import { Send } from 'lucide-react';
import { SpecifierLoginPrompt } from '~/modules/enquiry/component/specifier-login-prompt/SpecifierLoginPrompt';

/**
 * Displays a message when section content is not available with an option to request information
 */

interface SectionNotAvailableProps {
    description: React.ReactNode;
    enquiryButtonText: string;
    openEnquiryModal: (options?: {
        title?: string;
        ctaLabel?: string;
        addQueryParam?: boolean;
    }) => void;
    showEnquiryCTA?: boolean;
    showSpecifierLoginPrompt?: boolean;
    professionalName?: string;
}

export const SectionNotAvailable = ({
    enquiryButtonText,
    description,
    openEnquiryModal,
    showEnquiryCTA = true,
    showSpecifierLoginPrompt = false,
    professionalName = '',
}: SectionNotAvailableProps) => {
    const enquiryLabel = enquiryButtonText;

    return (
        <div className="flex flex-col items-start gap-8 pb-17 pt-8">
            <p className="text-lg">{description}</p>
            {showSpecifierLoginPrompt && (
                <SpecifierLoginPrompt
                    professionalName={professionalName}
                    itemDescription="this project"
                    showBottomBorder={false}
                    className="py-0"
                />
            )}
            {showEnquiryCTA && (
                <Button
                    color="primary"
                    className="uppercase"
                    onClick={() =>
                        openEnquiryModal({
                            title: enquiryLabel,
                            ctaLabel: enquiryLabel,
                        })
                    }
                >
                    {enquiryLabel}
                    <Send className="ml-2 size-4" />
                </Button>
            )}
        </div>
    );
};
